import React, {Component, Suspense} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {withRouter} from 'react-router-dom'
import axios from 'axios'
import {animateScroll} from 'react-scroll'
import {withAlert} from 'react-alert'

import {Wrapper} from './components/Styled'
import GlobalLoader from 'core/components/loader/GlobalLoader'
import Header from 'core/components/Header'
import UnreadMessenger from 'resources/react/core/components/UnreadMessenger'

import 'slick-carousel/slick/slick-theme.css'
import 'slick-carousel/slick/slick.css'

const Footer = React.lazy(() => import('core/components/Footer'))

class Layout extends Component {
  static defaultProps = {
    mobileFullMode: false,
    showSurvey: false
  }

  static propTypes = {
    alert: PropTypes.object,
    children: PropTypes.any,
    globalMediaNotification: PropTypes.string,
    globalNotification: PropTypes.string,
    globalVerifyEmailNotification: PropTypes.string,
    history: PropTypes.any,
    loginWithoutModal: PropTypes.func,
    logout: PropTypes.func,
    mobileFullMode: PropTypes.bool,
    showSurvey: PropTypes.bool
  }

  componentDidMount () {
    this.props.history.listen(this.onLocationChange)
    if (this.props.globalNotification) {
      this.props.alert.show(this.props.globalNotification)
    }

    if (this.props.globalMediaNotification) {
      this.props.alert.show(this.props.globalMediaNotification, {
        timeout: 0,
        onOpen: () => {
          let checkIfExists = setInterval(() => {
            if (document.getElementById('fix-message-link-profile')) {
              document.getElementById('fix-message-link-profile').addEventListener('click', function (e) {
                e.preventDefault()
                axios.get('/account/storefront/cancel-show-message-profile').then(() => {
                  window.location.href = e.target.href
                })
              })
              clearInterval(checkIfExists)
            }
          }, 100)
        },
        onClose: () => {
          axios.get('/account/storefront/cancel-show-message-profile')
        }
      })
    }

    if (this.props.globalVerifyEmailNotification) {
      this.props.alert.show(this.props.globalVerifyEmailNotification)
    }
  }

  onLocationChange = (location, action) => {
    // /puppies and /groomers have their own scroll rules, so we won't do anything there
    if (location.pathname.startsWith('/puppies/') || location.pathname.startsWith('/groomers/')) {
      return
    }

    // scroll top
    animateScroll.scrollTo(0, {
      duration: 500
    })
  }

  render () {
    return (
      <Wrapper>
        <GlobalLoader />
        <UnreadMessenger />
        {!this.props.showSurvey && <Header />}
        <div>
          {this.props.children}
        </div>
        {!this.props.mobileFullMode && !this.props.showSurvey && (
          <Suspense fallback={null}>
            <Footer />
          </Suspense>
        )}
      </Wrapper>
    )
  }
}

const mapStateToProps = state => ({
  mobileFullMode: state.app.mobileFullMode,
  showSurvey: state.app.show_survey,
  globalNotification: state.app.globalNotification,
  globalMediaNotification: state.app.globalMediaNotification,
  globalVerifyEmailNotification: state.app.globalVerifyEmailNotification
})

export default withRouter(connect(
  mapStateToProps,
  null
)(withAlert()(Layout)))
